import React from 'react';
import { AdvancedSettingsModal } from '@containers/DigitalAnalyst/AdvancedSettings';
import { useAdvancedSettings, useAdvancedSettingsInitialization } from '@hooks/application/useAdvancedSettings';
import { useDispatch } from 'react-redux';
import { advancedSettingsActionTypes } from '@constants/actionTypes';
import { AI_TOOLS } from '@constants';

const tool = AI_TOOLS.AGENT_FLOW;

export const AdvancedSettingsModalController = ({ onInit, updateNodeData }) => {
  const [activeNodeId, setActiveNodeId] = React.useState(null);
  const advancedSettingsValues = useAdvancedSettings();
  const dispatch = useDispatch();

  useAdvancedSettingsInitialization(tool);

  React.useEffect(() => {
    if (activeNodeId) {
      updateNodeData(activeNodeId, { advancedSettingsValues });
    }
  }, [activeNodeId, advancedSettingsValues]);

  const showModal = (nodeId) => {
    setActiveNodeId(nodeId);
    dispatch({ type: advancedSettingsActionTypes.showAdvancedSettings, payload: tool });
  };

  const hideModal = () => {
    setActiveNodeId(null);
    dispatch({ type: advancedSettingsActionTypes.hideAdvancedSettings });
  };

  React.useEffect(() => {
    onInit({ showModal, hideModal });
  }, []);

  if (!activeNodeId) {
    return null;
  }

  return <AdvancedSettingsModal onDismiss={hideModal} />;
};
